
(function(){
  const rows = [...document.querySelectorAll('section.tiles-section:not(.room-break)')];
  const grpOf = sec => sec.querySelector('figure.tile .ds')?.textContent;
  rows.forEach((sec, i) => {
    if (i > 0 && grpOf(sec) === grpOf(rows[i - 1])) return;                    // per-section breaks carry no header: every section opens with its own
    const el = document.createElement('section'); el.className = 'tiles-section room-break head-only';
    el.innerHTML = '<h2 class="rb-head"></h2>'; el.firstChild.textContent = grpOf(sec);
    sec.before(el);
  });
})();
